import React, { useState } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import logo from '../../assets/digitalparag/DigirtalParag.png'
import { Link, useNavigate } from 'react-router-dom'
import loginImage from "../../assets/login.jpg";
import { api_url } from '../../helpers/apiHelpers'
import { toast } from 'react-toastify'

const Forgot_password = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState("");
  const [otp, setOTP] = useState("");
  const [enteredotp, setEnteredOTP] = useState("");
  const [password, setPassword] = useState("");
  const [cPassword, setCPassword] = useState("");
  const sendOTP = async () => {
    if (email === "" || email === null) {
      toast.error("Enter Email Id")
    } else {
      const res = await fetch(`${api_url}/api/auth/check-mail`, {
        method: "POST",
        body: JSON.stringify({
          email
        }),
        headers: {
          "Content-Type": "application/json"
        }
      })
      const result = await res.json();
      console.log(result);

      if (result.status === 200) {
        toast.success(result.message)
        setOTP(result.otp)
      } else {
        toast.error(result.message)
      }
    }
  }
  const sendPassword = async () => {
    const res = await fetch(`${api_url}/api/auth/change-password`, {
      method: "POST",
      body: JSON.stringify({
        email,
        password
      }),
      headers: {
        "Content-Type": "application/json"
      }
    })
    const result = await res.json();
    if (result.status === 201) {
      toast.success(result.message)
      navigate('/sign_in')
    } else {
      toast.error(result.message)
    }
  }
  const [validOTP, setValidOTP] = useState(false);
  const checkOTP = () => {
    if (otp == enteredotp) {
      setValidOTP(true)
    } else {
      setValidOTP(false)
    }
  }
  return (
    <div>
      <Header />
      <br />
      <div className="flex w-full max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-lg  lg:max-w-4xl">
        <div
          className="hidden bg-cover lg:block lg:w-1/2"
          style={{
            backgroundImage: `url(${loginImage})`,
          }}
        ></div>

        <div className="w-full px-6 py-3 md:px-8 lg:w-1/2" style={{ backgroundColor: "#a3c8e8" }}>
          <div className="flex justify-center mx-auto">
            <img className="h-20 w-30 mr-3" src={logo} alt="Logo" />
          </div>
          <p className=" text-2xl text-center text-black ">
            Forgot your password?
          </p>

          <div className="mt-2">
            <label className="text-left block mb-2 text-base font-medium text-black " htmlFor="resetEmail">
              Email Address
            </label>
            <input
              id="resetEmail"
              className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
              type="email"
              placeholder="Enter your email"
              onChange={(e) => setEmail(e.target.value)}
              readOnly={otp ? true : false}
            />
            <p>{validOTP}</p>
          </div>



          {
            otp ? (<div className="mt-2">
              <label className="text-left block mb-2 text-base font-medium text-black " htmlFor="resetEmail">
                Enter OTP
              </label>
              <div className='flex justify-between'>
                <input
                  id="resetEmail"
                  className="block w-75 px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                  type="number"
                  placeholder="Enter OTP"
                  onChange={(e) => setEnteredOTP(e.target.value)}
                  readOnly={validOTP ? true : false}
                />
                <button onClick={() => checkOTP()} disabled={validOTP ? true : false} className="w-1/3 px-6 py-2 text-base font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50">
                  Confirm
                </button>
              </div>
              {validOTP ? (
                <label className="text-left block mb-2 text-base font-medium text-green-800 " htmlFor="resetEmail">
                  OTP matched
                </label>
              ) : (
                <label className="text-left block mb-2 text-base font-medium text-red-600 " htmlFor="resetEmail">
                  OTP not matched
                </label>
              )}
            </div>) : (
              <div className="mt-6">
                <button onClick={() => sendOTP()} disabled={otp ? true : false} className="w-1/2 px-6 py-2 text-base font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50">
                  Send Reset Link
                </button>
              </div>

            )
          }

          {validOTP && (
            <>
              <div className="mt-2">
                <label className="text-left block mb-2 text-base font-medium text-black " htmlFor="resetEmail">
                  New Password
                </label>
                <input
                  id="resetEmail"
                  className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                  type="password"
                  placeholder="Enter Password"
                  onChange={(e) => setPassword(e.target.value)}
                  readOnly={password && cPassword && password === cPassword ? true : false}
                />
              </div>
              <div className="mt-2">
                <label className="text-left block mb-2 text-base font-medium text-black " htmlFor="resetEmail">
                  Confirm Password
                </label>
                <input
                  id="resetEmail"
                  className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg  dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                  type="password"
                  placeholder="Enter Confirm Password"
                  onChange={(e) => setCPassword(e.target.value)}
                  readOnly={password && cPassword && password === cPassword ? true : false}
                />
              </div>
              <div className="mt-2">
                {password && cPassword && password === cPassword ? (
                  <label className="text-left block mb-2 text-base font-medium text-green-800 " htmlFor="resetEmail">
                    Password matched
                  </label>
                ) : (
                  <label className="text-left block mb-2 text-base font-medium text-red-600 " htmlFor="resetEmail">
                    Password not matched
                  </label>
                )}
              </div>
              <div className="mt-2">
                <button onClick={() => sendPassword()} className="w-1/2 px-6 py-2 text-base font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-gray-800 rounded-lg hover:bg-gray-700 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50">
                  Submit
                </button>
              </div>
            </>
          )
          }

          <div className="flex items-center justify-between mt-4">
            <span className="w-1/5 border-b dark:border-gray-600 lg:w-1/4"></span>
            <Link to="/sign_in" className="fw-bold text-base text-dark uppercase dark:text-gray-400 hover:underline">Back to login</Link>
            <span className="w-1/5 border-b dark:border-gray-600 lg:w-1/4"></span>
          </div>
        </div>
      </div >
      <br />
      <Footer />
    </div >
  )
}

export default Forgot_password
